import './radioGroup.scss';

import CssBaseline from '@mui/material/CssBaseline';

import { Radio } from '../Radio/Radio';
import { RadioGroupProps } from './types/RadioGroupProps';

export const RadioGroup = ({
  name,
  options,
  register,
  watch,
  defaultValue = '',
  labelPlacement = 'beside',
  variant = 'stacked',
  testId,
  onClick,
}: RadioGroupProps): JSX.Element => {
  const selectedValue = watch(name, defaultValue);

  return (
    <CssBaseline>
      <div
        className={`radio-group ${variant}`}
        data-testid={testId}
        role="radiogroup"
      >
        {options
          .filter((option) => option.condition !== false)
          .map((option) => (
            <Radio
              {...register(name)}
              checked={selectedValue === option.value}
              data-testid={option.testId}
              key={option.value}
              label={option.label}
              labelPlacement={labelPlacement}
              value={option.value}
              onClick={onClick}
            />
          ))}
      </div>
    </CssBaseline>
  );
};
